import React, { ReactElement, useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import { InjectionReference, resolveInjectionRef } from "../../InjectionHelper"
import { PropsDeChamp } from "..";
import { BaseEntite } from '../../../../../../../common/src/entities';

export default function ChampCascadeUnresolvedContentFromLocal<T, TEntite extends BaseEntite>(props: PropsDeChamp<T, TEntite>): ReactElement {
    const {
        children,
        injectionValue,
        injectionReferenceToResolved,
        notifyResolvedValue,
    } = props;

    useEffect(() => {
        const resolvedInjectionReferenceValue: T | T[keyof T] | undefined = injectionReferenceToResolved 
                                                                            ? resolveInjectionRef<T, TEntite>(injectionValue as T | T[], injectionReferenceToResolved as InjectionReference<T, TEntite>)
                                                                            : injectionValue;
        notifyResolvedValue(resolvedInjectionReferenceValue as (T | T[keyof T]));
    }, []);

    const childdrenWithInjectionButton: ReactElement[] = React.Children.map(children, child => {
        const childElement: ReactElement = child as ReactElement;
        if (React.isValidElement(childElement as ReactElement)) {
            return React.cloneElement(childElement, { 
                appendedChildren: <Spinner as="span" animation="border" role="status" aria-hidden="true" />,
            });
        }
        return childElement;
    });
    
    return <>{childdrenWithInjectionButton}</>;
}
